import script from "./ProcessTree.ts?vue&type=script&lang=ts"
export * from "./ProcessTree.ts?vue&type=script&lang=ts"

import "./ProcessTree.scss?vue&type=style&index=0&id=1cabc1d4&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cabc1d4"]])

export default __exports__